class ComponentImageVideoGrid extends HTMLElement {
    constructor() {
        super();

        this.sliderSlidesDesktop = parseFloat(this.dataset.slidesDesktop);
        this.sliderSlidesTablet = parseFloat(this.dataset.slidesTablet);
        this.sliderSlidesMobile = parseFloat(this.dataset.slidesMobile);
        this.sliderShowDots = this.dataset.dots == 'true';
        this.sliderShowArrows = this.dataset.arrows == 'true';
        this.sliderAutoplay = this.dataset.autoplay == 'true';
        this.sliderAutoplayDuration = parseFloat(this.dataset.duration);
        this.heroResize = this.dataset.heroResize == 'true';
        this.slider = null;
        this.sliderWrapper = this.querySelector('.keen-slider');
        
        this.initVideos();
        this.initCarousel();
    }
    getCurrentSlide() {
        if(this.carousel && this.carousel.currentSlide()) {
          return this.carousel.currentSlide();
        } else {
          return this.sliderWrapper.firstChild;
        }
      }
    initVideos() {
        if(this.hasVideos()) {
          this.updateVideos();
          var controls = this.sliderWrapper.querySelectorAll('.controls')
          controls.forEach(control => {
            var video = control.closest('.video-wrapper').querySelector('.video')

            control.addEventListener('click', ()=>{
              if (video.paused) {
                this.playVideo(video);
              } else{
                this.pauseVideo(video);
              }
            });
          })        

          window.addEventListener('mediaChange', ()=>{this.updateVideos()});
          
          window.addEventListener('scroll', $s.throttle(()=>{
            let _isInViewPort = $s.isInViewport(this.sliderWrapper);
            if(_isInViewPort!=this.isInViewPort) {
              this.updateVideos();
            }
          }, 500));
        }
      }
  
      updateVideos() {
     
        this.loadVideos();
        
      }
  
      hasVideos() {
        return this.sliderWrapper.querySelectorAll('.video').length > 0;
      }
  
      loadVideos() {
        this.sliderWrapper.querySelectorAll('video').forEach((video)=>{
          if($s.isVisible(video) && !video.dataset.initialized) {
            var source = video.querySelector('source');
            source.setAttribute('src', source.dataset.src);
            video.dataset.initialized = true;
            video.load();
          }
        });
      }
  
      playVideo(video) {
        if(video) {
          let videoWrap = video.closest('.video-wrapper');
          $s.playMedia(video);
          videoWrap.querySelector('.play').classList.add('hide');
          videoWrap.querySelector('.pause').classList.remove('hide');
        }
      }
  
      pauseVideo(video) {
        if(video) {
          let videoWrap = video.closest('.video-wrapper');
          $s.pauseMedia(video);
          video.load();
          videoWrap.querySelector('.play').classList.remove('hide');
          videoWrap.querySelector('.pause').classList.add('hide');

        }
    }

    initCarousel() {
        this.slider = new KeenSlider(this.sliderWrapper, {
            mode: "snap",
            loop: true,
            rubberband: false, 
            dots: this.sliderShowDots ? this.querySelector('.keen-dots') : '',
            prevButton: this.sliderShowArrows ? this.querySelector('.keen-arrow.prev') : '',
            nextButton: this.sliderShowArrows ? this.querySelector('.keen-arrow.next') : '',
            autoplay: this.sliderAutoplay,
            duration: this.sliderAutoplayDuration,
            slidesPerView: this.sliderSlidesDesktop,
            centered: this.sliderSlidesDesktop > this.sliderWrapper.querySelectorAll('.item').length ? true : false,
            breakpoints: {
                '(max-width: 1024px)': {
                    slidesPerView: this.sliderSlidesTablet,
                    centered: this.sliderSlidesTablet > this.sliderWrapper.querySelectorAll('.item').length ? true : false
                },
                '(max-width: 600px)': {
                    slidesPerView: this.sliderSlidesMobile,
                    centered: this.sliderSlidesMobile > this.sliderWrapper.querySelectorAll('.item').length ? true : false,
                    prevButton: this.sliderShowDots ? false : this.querySelector('.keen-arrow.prev'),
                    nextButton: this.sliderShowDots ? false : this.querySelector('.keen-arrow.next')
                }
            },
            slideChanged: ()=>{
                if(this.hasVideos()) {
                  this.updateVideos();
                }
              }
        });
    }
}
customElements.define('video-grid', ComponentImageVideoGrid);